import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('fu_token'));
  const [username, setUsername] = useState(() => localStorage.getItem('fu_username'));

  useEffect(() => {
    if (token) {
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common['Authorization'];
    }
  }, [token]);

  const login = async (usr, pwd) => {
    const { data } = await api.post('/auth/login', { username: usr, password: pwd });
    setToken(data.token);
    setUsername(data.username);
    localStorage.setItem('fu_token', data.token);
    localStorage.setItem('fu_username', data.username);
    api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
  };

  const logout = () => {
    setToken(null);
    setUsername(null);
    localStorage.removeItem('fu_token');
    localStorage.removeItem('fu_username');
    delete api.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ token, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
